import { Button, Form, Modal, Tabs, Row, Col } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { aboutUsEnumsArr, aboutUSkeys, contactEnumsArr, contactUSkeys, TAB_KEYS } from "../../../config";
import { useTab } from "../../../custom-hooks/useTab";
import { usePublishedEmptyTabWarning } from "../../../custom-hooks/usePublishedEmptyTabWarning";
import { useStore } from "../../../store";
import { setProSettingsData, setUpdatedValues } from "../../../store/actions";
import { formatData, withAboutUsGifBinaryFiles, isOrgAdminGifTab } from "../../../utils/formatData";
import { clearSavedGifLocalState } from "../../common/GifCreator";
import EmptyTabWarning from "../../common/EmptyTabWarning";
import "./index.scss";
import useTabsList from "./useTabsList";
import {
  CONTRACTS,
  CUSTOMER_SERVICES,
  GETTING_TO_US,
  VOLUNTEERING,
} from "../../../utils/constants";

function EditMicrosite({ micrositeId, newProSettings }) {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [form] = Form.useForm();

  const {
    getSingleTabData,
    dataLoader,
    callMicroServices,
    postLoader,
    getOptions,
  } = useTab();

 const { updatedValues, dispatch, settings } = useStore();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [nextTabKey, setNextTabKey] = useState(null);
 const [, setHasUnsavedChanges] = useState(false);

  const [activeKey, setActiveKey] = useState("");
  const [formChanged, setFormChanged] = useState(false);
  const [selectedActiveKey, setSelectedActiveKey] = useState(undefined);
 const [, setTabConfigId] = useState("");

  const { proSettingsObject, ProSettingsTabList } = useTabsList(newProSettings);

  const [splitParams, setSplitParams] = useState([]);
  const [tabId, setTabId] = useState("");
  const [tabIdLength, setTabIdLength] = useState(0);
  const [tabListArray, setTabListArray] = useState([]);
  const SubmitButton = ({ postLoader }) => {
    const getTabId = tabIdLength <= 1 ? tabId : splitParams[1];
    if (getTabId !== "work-experience" && getTabId !== "contract") {
      return (
        <div>
          {postLoader === true ? (
            <div>
              <Button className="saveBtn greenBtn">loading...</Button>
            </div>
          ) : formChanged ? (
            <Button
              className="saveBtn greenBtn"
              onClick={() => {
                form.submit();
              }}
            >
              Save All
            </Button>
          ) : (
            <Button
              className="saveBtn greenBtn"
              style={{ opacity: "0.5", pointerEvents: "none" }}
            >
              Save All
            </Button>
          )}
        </div>
      );
    } else if (getTabId === "contract") {
      return (
        <div>
          {postLoader === true ? (
            <div>
              <Button className="saveBtn greenBtn">loading...</Button>
            </div>
          ) : formChanged ? (
            <Button
              className="saveBtn greenBtn"
              onClick={() => {
                submit(form.getFieldValue());
              }}
            >
              Save All
            </Button>
          ) : (
            <Button
              className="saveBtn greenBtn"
              style={{ opacity: "0.5", pointerEvents: "none" }}
            >
              Save All
            </Button>
          )}
        </div>
      );
    } else {
      return <div></div>;
    }
  };


  const handleTabs = async (tabKey) => {

    // Don't show modal if clicking the same tab
    if (tabKey === activeKey) {
      return;
    }

    // Check if there are unsaved changes in current tab

    // if (unsavedChanges) {
    //   // Show modal and store the target tab
    //   setIsModalOpen(true);
    //   setNextTabKey(tabKey);
    //   setHasUnsavedChanges(true);
    // } else {
    //   // No unsaved changes, proceed with tab change
    //   await changeTab(tabKey);
    // }

    await changeTab(tabKey);
  };

  const changeTab = async (tabKey) => {
    const selectedTab = tabListArray?.find((tab) => tab.tabKey === tabKey);

    if (selectedTab) {
      localStorage?.setItem("selectedTabId", selectedTab?.id);
      setSelectedActiveKey(selectedTab?.id);
      stateUpdateHandler(tabKey, micrositeId)
      setTabConfigId(selectedTab.id);
      localStorage?.setItem("storeCurrentTabKey", tabKey);
    }

    callNavigation(tabKey, selectedTab?.id || selectedActiveKey);

    let TabKey = tabKey;
    if (
      tabKey === "SALES" ||
      tabKey === "HUMAN_RESOURCE" ||
      tabKey === "SOCIAL_MEDIA" ||
      tabKey === "EXPERIENCES_OF_WORK" ||
      tabKey === "REVIEWS" ||
      tabKey === "ADDRESS" ||
      tabKey === GETTING_TO_US ||
      tabKey === CUSTOMER_SERVICES ||
      tabKey === CONTRACTS ||
      tabKey === VOLUNTEERING
    ) {
      TabKey = "contact-us";
    }

    if (
      tabKey === "ABOUT_US" ||
      tabKey === "OUR_STORY" ||
      tabKey === "OUR_TEAM" ||
      tabKey === "OUR_CLIENT" ||
      tabKey === "ACCREDITATIONS_AWARDS" || 
      tabKey === "OUR_SUPPORTERS"
    ) {
      TabKey = "about-us";
    }

    if (TabKey === "about-us" && !splitParams[0]) {
      navigate(`/${micrositeId}`, {
        state: `about-us/${aboutUSkeys.About}`,
      });
      return;
    } else {
      setActiveKey(TabKey);
    }

    // Reset states
    setHasUnsavedChanges(false);
    setNextTabKey(null);
  };

  // Handle Save button - save data then move
  const handleSave = async () => {
    try {
      // Submit the form to save data
      await form.submit();

      // Wait for save to complete (you might need to adjust this based on your save implementation)
      setTimeout(() => {
        setIsModalOpen(false);
        if (nextTabKey) {
          changeTab(nextTabKey);
        }
      }, 1000); // Adjust timeout as needed based on your save operation
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };

  // Handle Move without save
  const handleMoveWithoutSave = () => {
    setIsModalOpen(false);
    if (nextTabKey) {
      changeTab(nextTabKey);
    }
  };

  // Handle Cancel - stay on current tab
  const handleCancel = () => {
    setIsModalOpen(false);
    setNextTabKey(null);
    setHasUnsavedChanges(false);
  };

  const callNavigation = async (key, id) => {
    if (contactEnumsArr.includes(key)) {
      navigate(`/${micrositeId}`, {
        state: `contact-us/${key}`,
      });
    } else if (aboutUsEnumsArr.includes(key)) {
      navigate(`/${micrositeId}`, {
        state: `about-us/${key}`,
      });
    } else if (key === TAB_KEYS.contactUs) {
      navigate(`/${micrositeId}`, {
        state: `${key + "/" + contactUSkeys.sales}`,
      });
    } else if (key === TAB_KEYS.aboutUs) {
      navigate(`/${micrositeId}`, {
        state: `${key + "/" + aboutUSkeys.About}`,
      });
    } else {
      navigate(`/${micrositeId}`, { state: `${key}` });
    }
  };

  const submit = async (info, saveIndex) => {
    console.log('info',info)
    let selectedTab = tabListArray.find((tab) => tab.tabKey === activeKey);
    localStorage?.setItem("selectedTabId", selectedTab?.id);
    setSelectedActiveKey(selectedTab?.id);
    let getTabId = tabIdLength <= 1 ? tabId : splitParams[1];
    getTabId = getTabId === "about-us" ? "ABOUT_US" : getTabId;
    let tabValues = info[getTabId];
    let valuesUpdated = updatedValues;
    if (typeof saveIndex === "number" && Array.isArray(tabValues)) {
      tabValues = [tabValues[saveIndex]];
      valuesUpdated = { [getTabId]: [0] };
    }
    if (isOrgAdminGifTab(getTabId) && Array.isArray(tabValues)) {
      const liveRows = form.getFieldValue(getTabId);
      const liveSlice =
        typeof saveIndex === "number" && Array.isArray(liveRows)
          ? [liveRows[saveIndex]]
          : liveRows;
      tabValues = await withAboutUsGifBinaryFiles(tabValues, liveSlice);
    }
    const formattedData = formatData(
      getTabId,
      tabValues,
      valuesUpdated,
      selectedTab?.id
    );
    if (Object.keys(formattedData).length > 0) {
      clearSavedGifLocalState(form, getTabId);
      dispatch(setUpdatedValues({}));
      callMicroServices(getTabId, formattedData, form, selectedTab?.id);
    } else if (getTabId === "work-experience") {
      toast.success("Data updated successfully");
    } else {
      toast.error("Nothing to update");
    }
  };

  const fieldsChange = (fields) => {
    if (fields && fields.length === 1) {
      const getNames = fields[0].name;
      const nameModified =
        getNames[0] === "aboutUs"
          ? "about-us"
          : getNames[0] === "workExperience"
            ? "work-experience"
            : getNames[0];
      var prev = updatedValues;

      const prevItems = prev[nameModified];
      if (prevItems) {
        const names = [...prevItems, getNames[1]];
        const removeDuplicates = names.filter(function (
          item,
          index,
          inputArray
        ) {
          return inputArray.indexOf(item) === index;
        });
        prev[nameModified] = removeDuplicates;
      } else {
        prev[nameModified] = [getNames[1]];
      }
      dispatch(setUpdatedValues(prev));
    }
  };

  const onClickArrow = (direction) => {
    const modifiedTabLists = tabListArray?.filter(
      (d) =>
        !(d.settingsKey in settings) ||
        (d.settingsKey in settings && settings[d.settingsKey] !== false)
    );
    const getIndex = modifiedTabLists.findIndex((d) => d.tabKey === activeKey);

    if (getIndex !== -1) {
      if (direction === "right" && modifiedTabLists[getIndex + 1].tabKey) {
        handleTabs(modifiedTabLists[getIndex + 1].tabKey);
      } else if (
        direction === "left" &&
        modifiedTabLists[getIndex - 1].tabKey
      ) {
        handleTabs(modifiedTabLists[getIndex - 1].tabKey);
      }
    }
  };

  useEffect(() => {
    if (tabId && tabId !== " ") {
      if (tabIdLength === 1 && splitParams[0] === TAB_KEYS.contactUs) {
        navigate(`/${micrositeId}`, {
          state: `${splitParams[0]}/${contactUSkeys.sales}`,
        });
      } else if (tabIdLength === 1 && splitParams[0] === TAB_KEYS.aboutUs) {
        navigate(`/${micrositeId}`, {
          state: `${splitParams[0]}/${aboutUSkeys.About}`,
        });
      } else {
        navigate(`/${micrositeId}`, { state: tabId });
      }
    } else {
      navigate(`/${micrositeId}`, { state: `${TAB_KEYS.aboutUs}` });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [micrositeId, tabId, tabIdLength, splitParams]);

  useEffect(() => {
    if (selectedActiveKey) {
      localStorage?.setItem("selectedTabId", selectedActiveKey);
    }
    else {
      localStorage?.removeItem("selectedTabId");
    }
    if (selectedActiveKey && tabId && tabId !== "") {
      if (
        splitParams[1] !== CONTRACTS &&
        splitParams[1] !== VOLUNTEERING &&
        splitParams[1] !== CUSTOMER_SERVICES &&
        splitParams[1] !== GETTING_TO_US
      ) {
        getSingleTabData(
          tabIdLength <= 1 ? tabId : splitParams[1],
          form,
          selectedActiveKey,
        );
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabIdLength, tabId, tabListArray, selectedActiveKey, splitParams]);

  useEffect(() => {
    if (micrositeId && proSettingsObject) {
      // if proSetting is disabled masterData key will not be there prevent api call
      if (proSettingsObject?.["35499238-0937-11f0-b61c-6045bd0fa337"]?.id)
        getOptions(
          micrositeId,
          "PRODUCT",
          proSettingsObject?.["35499238-0937-11f0-b61c-6045bd0fa337"]?.id
        );
      if (proSettingsObject?.["35499b63-0937-11f0-b61c-6045bd0fa337"]?.id)
        getOptions(
          micrositeId,
          "COURSES",
          proSettingsObject?.["35499b63-0937-11f0-b61c-6045bd0fa337"]?.id
        );
      if (proSettingsObject?.["35499ab7-0937-11f0-b61c-6045bd0fa337"]?.id)
        getOptions(
          micrositeId,
          "TEAMS_AND_ROLES",
          proSettingsObject?.["35499ab7-0937-11f0-b61c-6045bd0fa337"]?.id
        );
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [micrositeId, proSettingsObject]);


  const stateUpdateHandler = (state, micrositeId) => {
    if (state === "about-us") {
      navigate(`/${micrositeId}`, {
        state: `about-us/${aboutUSkeys.About}`,
      });
    }
    if (state?.length > 0) {
      const tabId = state;
      setTabId(state);

      const tempSplitParams = tabId
        ? tabId?.split("/").filter(function (entry) {
          return entry.trim() !== "";
        })
        : [];
      setSplitParams(tempSplitParams);

      setTabIdLength(tempSplitParams.length);
    } else {
      navigate(`/${micrositeId}`, {
        state: `about-us/${aboutUSkeys.About}`,
      });
    }
  }
  useEffect(() => {
    stateUpdateHandler(state, micrositeId)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state, micrositeId]);

  useEffect(() => {
    const isNotEmpty = Object.keys(updatedValues).length > 0;

    setFormChanged(isNotEmpty);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Object.keys(updatedValues).length]);


  window.addEventListener("beforeunload", () => {
    localStorage.removeItem("storeCurrentTabKey");
  });

  useEffect(() => {
    let tabActiveKey = tabIdLength <= 1 ? tabId : splitParams[0];
    let selectedTab = tabListArray.find((tab) => tab.tabKey === tabActiveKey);
    if (selectedTab) {
      setActiveKey(selectedTab?.tabKey);
    }

    if (!settings[selectedTab?.settingsKey]) {
      setTimeout(() => {
        handleTabs(localStorage?.getItem("storeCurrentTabKey") || "about-us");
      }, 500);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    settings?.businessCard,
    settings?.apprenticeships,
    settings?.experienceOfWork,
    settings?.teamsAndRoles,
    settings?.products,
    settings?.services,
    settings?.contracts,
    settings?.vacancies,
    settings?.whyWork,
    tabListArray,
  ]);

  useEffect(() => {
    let selectedTab = tabListArray.find((tab) => tab.tabKey === activeKey);
    let carouselId = tabListArray.find(
      (tab) => (tab.displayName === "Home carousel" || tab.oldName === "Home carousel")
    )?.id;
    localStorage?.setItem("carouselId", carouselId);

    setSelectedActiveKey(selectedTab?.id);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabListArray]);

  useEffect(() => {
    setTabListArray(ProSettingsTabList);
    dispatch(setProSettingsData({ proSettingData: ProSettingsTabList }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ProSettingsTabList]);

  const currentIndex = tabListArray.findIndex(
    (tab) => tab.tabKey === activeKey
  );
  const currentTabDataKey = tabIdLength <= 1 ? tabId : splitParams[1];
  const skipCentralEmptyWarning =
    currentTabDataKey === TAB_KEYS.workExperience ||
    currentTabDataKey === CUSTOMER_SERVICES ||
    currentTabDataKey === CONTRACTS ||
    currentTabDataKey === VOLUNTEERING ||
    currentTabDataKey === GETTING_TO_US;
  const { show: showEmptyTabWarning, tabName: emptyTabName } =
    usePublishedEmptyTabWarning({
      tabKey: currentTabDataKey,
      fallbackName: tabListArray.find((tab) => tab.tabKey === activeKey)
        ?.displayName,
      loaded: !dataLoader,
    });
  return (
    <React.Fragment>
      {activeKey ? (
        <div className="tabHeadContainer">
          <Form
            form={form}
            autoComplete="off"
            name='microsite-form'
            onFinish={(values) => {
              submit(values);
            }}
            onFieldsChange={fieldsChange}
          >
            <Tabs
              type="card"
              className="tabBodyContainer"
              onChange={handleTabs}
              activeKey={activeKey}
              destroyInactiveTabPane={false}
              tabBarExtraContent={
                <div style={{ display: "flex", alignContent: "center" }}>
                  {/* Left / Prev Button */}
                  <div
                    className={`leftArrow ${currentIndex === 0 ? "disabled" : ""
                      }`}
                    onClick={() => currentIndex > 0 && onClickArrow("left")}
                    style={{
                      pointerEvents: currentIndex === 0 ? "none" : "auto",
                      opacity: currentIndex === 0 ? 0.4 : 1,
                    }}
                  >
                    <img
                      className="arrow-nav-btn"
                      src={require("../../../assets/images/Path3954.png")}
                      alt="prev"
                    />
                    <img
                      className="arrow-nav-btn"
                      src={require("../../../assets/images/Path3954.png")}
                      alt="prev"
                    />
                  </div>

                  {/* Right / Next Button */}
                  <div
                    className={`rightArrow ${currentIndex === tabListArray.length - 1 ? "disabled" : ""
                      }`}
                    onClick={() =>
                      currentIndex < tabListArray.length - 1 &&
                      onClickArrow("right")
                    }
                    style={{
                      pointerEvents:
                        currentIndex === tabListArray.length - 1
                          ? "none"
                          : "auto",
                      opacity:
                        currentIndex === tabListArray.length - 1 ? 0.4 : 1,
                    }}
                  >
                    <img
                      className="arrow-nav-btn"
                      src={require("../../../assets/images/Path3900.png")}
                      alt="next"
                    />
                    <img
                      className="arrow-nav-btn"
                      src={require("../../../assets/images/Path3900.png")}
                      alt="next"
                    />
                  </div>
                </div>
              }
              items={tabListArray?.map((tab) => ({
                key: tab.tabKey,
                label: tab.displayName,
                className: "contactUsContent",
                children:
                  activeKey === tab.tabKey ? (
                    <div className="scrollable-tab-content">
                      {!skipCentralEmptyWarning && showEmptyTabWarning && (
                        <EmptyTabWarning tabName={emptyTabName} />
                      )}
                      {tab.component({
                        dataLoader,
                        form,
                        handleTabs,
                        splitParams,
                        activeKey,
                        getSingleTabData,
                        tab,
                        tabHandleSaveClick: (form, saveIndex) => {
                          submit(form.getFieldValue(), saveIndex);
                        },
                      })}
                    </div>
                  ) : null,
              }))}
            />
            <Row>
              <Col
                className="gutter-row tabContent"
                span={24}
              >
                <Col
                  className="gutter-row tabContent"
                  xs={24}
                  sm={24}
                  md={14}
                  lg={14}
                  style={{ paddingRight: "25px" }}
                >
                  <div className="submit-section-bottom">
                    <SubmitButton postLoader={postLoader} />
                  </div>
                </Col>
                <Col
                  className="gutter-row tabContent"
                  xs={24}
                  sm={24}
                  md={10}
                  lg={10}
                ></Col>
              </Col>
            </Row>

          </Form>
          <Modal
            open={isModalOpen}
            onCancel={handleCancel}
            footer={[
              <Button
                key="save"
                type="primary"
                onClick={handleSave}
                className="saveAndMove"
              >
                Save and Move
              </Button>,
              <Button
                key="move"
                onClick={handleMoveWithoutSave}
                className="moveOnly"
              >
                Move
              </Button>,
              <Button key="cancel" onClick={handleCancel} className="cancelBtn">
                Cancel
              </Button>,
            ]}
          >
            <div className="tab-changes" style={{ padding: "40px 0 20px" }}>
              You have unsaved changes. Would you like to save before moving to
              the next tab?
            </div>
          </Modal>
        </div>
      ) : null}

      {/* {generatingAI?.isGeneratingData && (
        <div className="ai-loader-container">
          <div className="ai-loader-spinner"></div>
          <span className="ai-loader-text">Content is Generating...</span>
        </div>
      )} */}
    </React.Fragment>
  );
}

export default EditMicrosite;
